​import { ChangeDetectorRef, Component, EventEmitter, HostListener, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import { QBuiltInspectorConstants } from '../../models/constants/qbuilt-inspector.constants';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QBuiltSharedInspService } from '../services/qbuilt-shared.service';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { QBuiltInspectorDialogService } from '../services/inspector-dialog.service';
import { QBuiltService } from 'src/app/modules/qbuilt/services/qbuilt-service';
import { QBuiltInspectorService } from '../../services/qbuilit-inspector.service';
import { TaskExecution } from '../models/task-execution.models';
import { DefectedTaskModel, InjectedTaskModel, InspectionCompletionModel, TaskExecutionResultModel } from '../../models/qbuilt-inspector.models';
import { MatSnackBar } from 'src/app/shared/material';
import { Router } from '@angular/router';
import { SerialTabModel } from '../models/serial-tab.models';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { TaskGroupsComponent } from '../task-groups/task-groups.component';
import { DefectModel } from '../models/defect.model';
import { v4 as uuidv4 } from 'uuid';
import { OpenDefectTableComponent } from '../open-defect-table/open-defect-table.component';
import { DefectFormComponent } from '../defect-form/defect-form.component';
import { firstValueFrom, take } from 'rxjs';

@Component({
    selector: 'inspection-content',
    imports: [
        MatCardModule,
        MatExpansionModule,
        MatTableModule,
        MatIconModule,
        MatCheckbox,
        CommonModule,
        FormsModule,
        MatProgressBarModule,
        TaskGroupsComponent,
        OpenDefectTableComponent,
        DefectFormComponent
    ],
    animations: [
        trigger('detailExpand', [
            state('collapsed,void', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    templateUrl: './inspection-content.component.html',
    styleUrl: './inspection-content.component.scss',
    encapsulation: ViewEncapsulation.Emulated
})
export class InspectionContentComponent {
  //session storage keys
  defectItemsKey: string = this.qBuiltInspectorConstants.defectItemsKey;
  cqmsSessionKey: string = this.qBuiltInspectorConstants.cqmsItemsKey;

  @Input() tabData: SerialTabModel;
  @Input() sectionList: any[] = [];
  @Output() emitContentLoad = new EventEmitter<any>();
  @Output() emitCompleteTab = new EventEmitter<any>();
  zoneSelection: string = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').zoneName || JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').currentTabList[0]?.zoneSelection || '';
  panelOpenState = false;
  showText: boolean = false; // This will toggle the display of the text in the table cells

  signOffBtnText: string = this.qBuiltInspectorConstants.signOffBtnText;

  checklistColumn: string = this.qBuiltInspectorConstants.checklistItemColumn;
  defectColumn: string = this.qBuiltInspectorConstants.defectColumn;
  naColumn: string = this.qBuiltInspectorConstants.naColumn;
  passColumn: string = this.qBuiltInspectorConstants.passColumn;

  dataSource: any[] = [];
  tableColumns: string[] = ['Checklist Item', 'Defect','NA','Pass'];
  openDefectTableColumns: string[] = ['Open Defects', 'Delegate','Fix'];

  stationList: any[] = [];
  observedTaskList: any[] = [];

  singleWide: boolean = true;
  serialNumber: string = '';

  isChecked: boolean = false;

  validInspection: boolean = false;

  userId: number;
  userName: string = '';

  completeSectionList: any[] = [];
  finalSection: boolean = false;

  observedDefectTxt: string = this.qBuiltInspectorConstants.observedDefectTxt;

  updatedData: any;

  columnsToDisplayWithExpand = [...this.tableColumns, 'Expand'];
  expandedElement: TaskExecution | null;

  facilityNumber: string = sessionStorage.getItem('facilityNumber') || '';
  currentZoneId: string = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').zoneId || '';

  //defect specific
  defectList: any[] = [];
  defectFormList: any[] = [];

  addAdditionalDefectText: string = this.qBuiltInspectorConstants.addAdditionalDefectText;

  openTasks: any[] = [];
  taskExecutionIds: any[] = [];

  locations: any[] = [];
  departments: any[] = [];
  observedDefectTasks: any[] = [];
  nonObservedTaskIds: number[] = [];

  isLoading: boolean = true;

  constructor(public qBuiltInspectorConstants: QBuiltInspectorConstants,
    public qbuildSharedSrv: QBuiltSharedInspService,
    private qbuiltDialog: QBuiltInspectorDialogService,
    private qbuiltSrv: QBuiltService,
    private qbuiltInspSrv: QBuiltInspectorService,
    private toaster: MatSnackBar,
    private router: Router,
    private cdr: ChangeDetectorRef,

  ) {
    this.qbuildSharedSrv.currentDataList$.subscribe(dataList => {
      this.sectionList = dataList;
    });

  }

  ngOnInit() {
    this.isLoading = true;
    this.locations = localStorage.getItem('locations') ? JSON.parse(localStorage.getItem('locations')) : [];
    this.departments = localStorage.getItem('departments') ? JSON.parse(localStorage.getItem('departments')) : [];
    this.observedDefectTasks = localStorage.getItem('configuredTasks') ? JSON.parse(localStorage.getItem('configuredTasks')) : [];
    this.sectionList = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').sectionList || [];
    this.defectList = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectList || [];
    this.tabData.sectionCount > 1 ? this.singleWide = false : this.singleWide = true;
    this.serialNumber = this.tabData.serialNumber;
    this.setupUserData();
    this.getCustomTaskGroups();
    this.getObservedDefectData();
    this.completedSectionCheck(this.sectionList);

    this.defectList = this.extractDefectsFromTab(this.tabData);
    this.defectFormList = this.convertDefectListToFormList(this.defectList);
    let cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
    cqmsDefectItems = { ...cqmsDefectItems, defectList: this.defectList, defectFormList: this.defectFormList };
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
  }

@HostListener('window:popstate', ['$event'])
onPopState(event: any) {
  sessionStorage.removeItem(this.defectItemsKey);
  sessionStorage.removeItem(this.cqmsSessionKey);
}

extractDefectsFromTab(tabData: SerialTabModel): any[] {
  const defects: any[] = [];
  const currentDefectList: any[] = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectList || [];

  if(currentDefectList.length > 0) {
    tabData.sectionList?.forEach((section: any) => {
      section.Stations?.forEach((station: any) => {
        station.DefectedTasks?.forEach((defect: any) => {
          defects.push(defect);
        });
      });
    });
  } else {
    tabData.sectionList?.forEach((section: any) => {
      section.Stations?.forEach((station: any) => {
        station.DefectedTasks?.forEach((defect: any) => {
          const alreadyExists = currentDefectList.some((d: any) => d.Id === defect.Id);
          if (!alreadyExists) {
            defects.push(defect);
          }
        });
      });
    });

  }
  return defects;
}

convertDefectListToFormList(defectList: any[]): any[] {
  if (!defectList || defectList == null || defectList.length === 0) return [];

  return defectList.map(defect => ({
    id: defect.Id || 0,
    defectId: defect.Id,
    departmentId: defect.DepartmentId || 0,
    locationId: defect.LocationId || null,
    quantity: defect.DefectQuantity || 1,
    defectDesc: defect.Description || '',
    designateStation: false,
    stationName: '',
    stationId: defect.StationId || 0,
    statusId: defect.StatusId || 1
  }));
}

 
  //Gathers the open tasks for Open Defect table 
  openTaskCheck(stationDefectedTasks: any[]) {
    this.openTasks = [];
    this.sectionList.forEach(section => {
      section.Stations.forEach((station: any) => {
        station.TaskExecutions.forEach((task: any) => {
          if(!this.taskExecutionIds.includes(task.Id)) {
            //creates a list of all task execution ids for the current inspection
            //this is used later to compare with open defects list
            this.taskExecutionIds.push(task.Id);
          }
        });
      })
    });

    stationDefectedTasks.forEach((task: any) => {
      const isNewExecution = !this.taskExecutionIds.includes(task.TaskExecutionId);
      const isOpenStatus = task.StatusId === 2 || task.StatusId === 3 || task.StatusId === 5;
      const alreadyThere = this.defectList.some((defect: any) => defect.Id === task.Id);

      if (isNewExecution && isOpenStatus) {
        this.openTasks.push(task);
        if (!alreadyThere) {
          this.defectList.push(task);
        }
      }
    });

    const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
    cqmsDefectItems.defectList = this.defectList;
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));

    if(this.openTasks.length > 0) {
      this.emitContentLoad.emit(true);
    } else {
      this.emitContentLoad.emit(false);
    }
    return this.openTasks;
  }

  setupUserData() {
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null;
    if (userData) {
      this.userId = userData.UserId;
      this.userName = userData.FirstName + ' ' + userData.LastName;
    }
    
  }

  
// used for multisection inspections after user returns to page from landing page
completedSectionCheck(sectionList: any[]) {
  this.sectionList.forEach(section => {
    // check that every station in this section has all tasks complete
    const allStationsComplete = section.Stations.every(
      (station: any) =>
        station.TaskExecutions.length > 0 &&
        station.TaskExecutions.every((task: any) => task.TaskStatusId === 4)
    );

    if (allStationsComplete) {
      if (!this.completeSectionList.includes(section.SectionId)) {
        this.completeSectionList.push(section.SectionId);
      }
    } else {
      // remove section from complete list if not all stations are complete
      this.completeSectionList = this.completeSectionList.filter(
        (id: any) => id !== section.SectionId
      );
    }
  });

  let cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
  cqmsSessionItems.completeSectionList = this.completeSectionList;
  sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
  
}

  //used for non single wides
  //determines if the section is complete and displays 'Complete' text rather than signoff button
  //Also used as temp disabling of section expansion if complete
  completeCheck(sectionId?: number): boolean {
    return this.completeSectionList.includes(sectionId);
  }

  NADisableCheck(element: any) {
    return element.ResultValue === 'Defect' || element.ResultValue === 'Pass' || element.TaskStatusId === 4;
  }

  passDisableCheck(element: any) {
    return element.ResultValue === 'Defect' || element.ResultValue === 'NA' || element.TaskStatusId === 4;
  }

  naHiddenCheck(element: any) {
    if(element.ResultValue !== 'Defect' && element.ResultValue !== 'Pass' && element.ResultValue !== 'NA' && element.ResultValue !== null) {
      return true;
    }
    return false;
  }

  getCustomTaskGroups() {
    //NA
    this.qbuiltInspSrv.getCustomTaskGroups({
      GroupName: 'NA',
      FacilityNumber: this.facilityNumber //pulled from session storage
    });
    this.qbuiltInspSrv.customGroups$.subscribe((data) => {
      if(data) {
        let cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
        cqmsSessionItems.customTaskGroups = data.Tasks;
        sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
      }
    });
  }

  getObservedDefectData() {
    let observedTasks = localStorage.getItem('configuredTasks') ? JSON.parse(localStorage.getItem('configuredTasks')) : [];
    this.observedTaskList = this.qbuiltSrv.getOptionalTasks(observedTasks);
    this.isLoading = false;
  }


  onCheckboxChange(event: any, element: any, type: string, sectionId: string, stationId: string): void {
    this.qbuiltInspSrv.booleanList.next([]);
    this.defectList = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectList || [];
    this.defectFormList = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectFormList || [];
    element.PerformedByQTUserId = this.userId || null;
    element.FromStationId = stationId || null;

    if (event.checked) {
      const resultMap: { [key: string]: string } = {
        pass: 'Pass',
        na: 'NA',
        defect: 'Defect'
      };
      element.ResultValue = resultMap[type] || null;
      if(type === 'defect') {
        //create new defected task and form task
        let newDefectTask = this.createDefectedTask(element, parseInt(stationId));
        //push to defect list
      if(!this.defectList.includes(newDefectTask.Id)) {
        this.defectList.push(newDefectTask);
        let formDefect = this.convertDefectListToFormList([newDefectTask])[0];
        this.defectFormList.push(formDefect);
      }
        //add that new task to the correct section/station defectedTasklist
        this.sectionList.forEach(section => {
          if(section.SectionId === sectionId) {
            section.Stations.forEach((station:any) => {
              if(station.Id === parseInt(stationId)) {
                station.DefectedTasks.push(newDefectTask);
              }
            });
          }
        })
      }
    } else {
      if (type === 'defect') {
        this.sectionList.forEach(section => {
          if(section.SectionId === parseInt(sectionId)) {
            section.Stations.forEach((station:any) => {
              if(station.Id === parseInt(stationId)) {
                station.DefectedTasks.forEach((d: any) => {
                  //Save progress path - dont remove from defect list, just mark as deleted true
                  //updated UI to hide the defect if isDeleted = true in case they readd the particular taskExecutionId back
                  if(d.TaskExecutionId === element.Id && typeof d.Id === 'number') {
                    d.IsDeleted = true;
                    this.defectList = this.defectList.map(defect => d.Id === defect.Id ? {...defect, IsDeleted: true} : defect);
                  } else {
                    //happy path - remove defect
                    this.defectList = this.defectList.filter((d: any) => d.TaskExecutionId !== element.Id);
                    const remainingIds = new Set(this.defectList.map((d: any) => d.Id ?? d.defectId ?? d.TaskExecutionId));
                    this.defectFormList = this.defectFormList.filter((d: any) => remainingIds.has(d.defectId) || remainingIds.has(d.id));
                    station.DefectedTasks = station.DefectedTasks.filter((d: any) => d.TaskExecutionId !== element.Id);
                    // For observed defects (UUID string Id), also remove the TaskExecution that was
                    // added by createObservedDefectTask — otherwise the row lingers in the table.
                    if (typeof element.Id === 'string') {
                      station.TaskExecutions = station.TaskExecutions.filter((task: any) => task.Id !== element.Id);
                    }
                  }
                });
              }
            })
          }
        }
        )
  }
      element.ResultValue = null;
    }
    
    const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
    cqmsDefectItems.defectList = this.defectList;
    cqmsDefectItems.defectFormList = this.defectFormList;
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
    this.qbuildSharedSrv.setCurrentDefectList(this.defectList);
    let cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems = {...cqmsSessionItems, sectionList: this.sectionList, capturedChanges: true, currentStationId: stationId};
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
    this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
    this.updateCurrentTabList(this.sectionList);
  }

  //Determines if defect has been locked 
  //A defect is considered locked if defect under it has been deferred (status 2) or fixed (status 3)
  //Dont want to lose this data
  defectLocked(element: any, section: any): boolean {
    const stationDefects = section.Stations.flatMap((station: any) => station.DefectedTasks);
    const defectTasks = stationDefects.filter((defect: any) => defect.TaskExecutionId === element.Id && defect.IsDeleted !== true);
    const defectStatusIds = defectTasks.map((defect: any) => defect.StatusId);
    return defectStatusIds.some((statusId: any) => statusId === 2 || statusId === 3);
  }

  //Checks for open defects and returns true to update styling
  openDefects(element: any, section: any): boolean {
    const stationDefects = section.Stations.flatMap((station: any) => station.DefectedTasks);
    const defectTasks = stationDefects.filter((defect: any) => defect.TaskExecutionId === element.Id && defect.IsDeleted !== true);
    const defectStatusIds = defectTasks.map((defect: any) => defect.StatusId);
    return defectStatusIds.some((statusId: any) => statusId === 1);
  }

  filterDefects(taskExecutionId: number): DefectModel[] {
    return this.defectList.filter(d => d.TaskExecutionId === taskExecutionId);
  }

  //sets the dept id for the defect form based on prepopulated value
getDeptData(departmentTypes: any) {
  let allTasks = localStorage.getItem('configuredTasks') ? JSON.parse(localStorage.getItem('configuredTasks')) : [];
  const deptNames = Array.isArray(departmentTypes)
    ? departmentTypes
    : [departmentTypes];

  const task = allTasks.find((t: any) =>
    t.InspectionTaskDepartments?.some((d: any) =>
      deptNames.includes(d.DepartmentName)
    )
  );

  if (!task) return null;

  const primary = task.InspectionTaskDepartments.find((d: any) => d.IsPrimary);
 return primary.DepartmentId;

}



    /**
   * Opens dialog for observed defect and passes back selection from user
   * TODO -- implement code to add defect to list based on station id
   * @param stationId 
   */
  addObservedDefect( sectionId : any, stationId: any) {
    const tasksInInspection = new Set<string>(
      this.sectionList.flatMap((section: any) =>
        section.Stations.flatMap((station: any) =>
          station.TaskExecutions.map((t: any) => String(t.TaskId))
        )
      )
    );

    const nonVisibleTasks = this.observedDefectTasks.filter(
      task => task.InspectionTaskName === 'Comment' || task.InspectionTaskName === 'StationDeferralSelection'
    );
    this.nonObservedTaskIds = nonVisibleTasks.map((task: any) => task.InspectionTaskId);

    const availableTasks = this.observedDefectTasks.filter(task =>
      !tasksInInspection.has(String(task.InspectionTaskId)) &&
      !this.nonObservedTaskIds.includes(task.InspectionTaskId)
    );

    const dialogRef = this.qbuiltDialog.openInspectorDialog(3, availableTasks);

    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.createObservedDefectTask(result, parseInt(sectionId), parseInt(stationId));
        const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
        cqmsDefectItems.defectList = this.defectList;
        sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
      }
        this.updateCurrentTabList(this.sectionList);
    });
  }

createObservedDefectTask(parentTask: any, sectionId: number, stationId: number) {

  const deptTypes = parentTask.InspectionTaskDepartments
    .filter((id: any) => id.IsPrimary === true)
    .map((id: any) => id.DepartmentName);

  const newTaskExecution = {
    Id: uuidv4(),
    PerformedByQTUserId: this.userId || null,
    InjectedByQTUserId: this.userId || null,
    AssignedStationId: stationId || null,
    FromStationId: stationId || null,
    TaskStatus: "New",
    TaskStatusId: 1,
    ResultValue: "Defect",
    TaskId: parentTask.InspectionTaskId,
    TaskName: parentTask.InspectionTaskName,
    InclusionTypeId: 6,
    DepartmentTypes: deptTypes,
  };

  const defectTask = this.createDefectedTask(newTaskExecution, stationId);
  defectTask.InjectedByQTUserId = this.userId || null;
  const section = this.sectionList.find((s: any) => s.SectionId === sectionId);
  if (section) {
    const station = section.Stations.find((st: any) => st.Id === stationId);
    if (station) {
      station.TaskExecutions = [...station.TaskExecutions, newTaskExecution];
      station.DefectedTasks = [...station.DefectedTasks, defectTask];
    }
  }

  // Update defectLists
  this.defectList.push(defectTask);
  this.defectFormList = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectFormList || this.defectFormList;

  let cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
  cqmsSessionItems = {...cqmsSessionItems, sectionList: this.sectionList, currentStationId: stationId};
  sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
  
  const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
  cqmsDefectItems.defectList = this.defectList;
  sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));

  this.qbuildSharedSrv.setCurrentDefectList(this.defectList);
  this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
  this.updateCurrentTabList(this.sectionList);

  return defectTask;
}


 //Add Additional Defect Under Checklist Item
  addDefect(element: any, sectionId: any) {
    this.defectList = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectList || [];
    //create new defect task
    let defectTask = this.createDefectedTask(element, element.AssignedStationId);
    this.defectList.push(defectTask);
    //add that new task to the correct section/station defectedTasklist
    this.sectionList.forEach(section => {
      if(section.SectionId === sectionId) {
        section.Stations.forEach((station:any) => {
          if(station.Id === element.AssignedStationId) {
            station.DefectedTasks.push(defectTask);
          }
        });
      }
    });

    const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
    cqmsDefectItems.defectList = this.defectList;
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
    this.qbuildSharedSrv.setCurrentDefectList(this.defectList);

    let cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems = {...cqmsSessionItems, sectionList: this.sectionList, currentStationId: element.AssignedStationId};
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
    this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
    this.updateCurrentTabList(this.sectionList);

    return defectTask;
  }

  isStringId(id: any): boolean {
  return typeof id === 'string' && id.trim().length > 0;
}

  //When user selects defect a DefectedTask is generated and added to the DefectedTasks array
  createDefectedTask(parentTask: any, stationId: number) {

    let defaultDeptId = this.getDeptData(parentTask.DepartmentTypes);
    const defectedTask = {
      Id: uuidv4(),
      SerialNumber: this.serialNumber,
      TaskExecutionId: parentTask.Id,
      TaskId: parentTask.TaskId || parentTask.InspectionTaskId,
      LocationId: 0,
      DepartmentId: defaultDeptId,
      StatusId: 1,
      ClosedByQTUserId: 0,
      Description: '',
      DefectQuantity: 1,
      StationId: stationId,
      AttachmentLocationKeys: [] as string[],
      AttachmentType: '',
      IsDeleted: false,
      InjectedByQTUserId: null as number | null
    };
    const formValue = {
      taskExecutionId: parentTask.Id,
      defectId: defectedTask.Id,
      departmentId: defaultDeptId,
      defectDesc: '',
      locationId: null as string | number | null,
      quantity: 1,
      designateStation: false,
      stationName: '',
      statusId: 1
    }
    let defectFormList = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectFormList || [];
    defectFormList.push(formValue);
    const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
    cqmsDefectItems.defectFormList = defectFormList;
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
    
    return defectedTask;
  }

  //removes individual defect from defect list and sectionList
onRemoveIndividualDefect(event: any, sectionId: number, element: any) {
  const isExistingDefect = typeof event.defectId === 'number';
  this.sectionList.forEach(section => {
    if (section.SectionId === sectionId) {
      section.Stations.forEach((station: any) => {
        if (station.Id === element.AssignedStationId) {
          if (isExistingDefect) {
            station.DefectedTasks.forEach((defect: any) => {
              if (defect.Id === event.defectId) {
                defect.IsDeleted = true;
              }
            });
          } else {
            station.DefectedTasks = station.DefectedTasks.filter((defect: any) => defect.Id !== event.defectId);
            if(typeof element.Id === 'string' && this.finalDefectTask(element, station.DefectedTasks)) {
               station.TaskExecutions = station.TaskExecutions.filter((task: any) => task.Id !== element.Id);
            }
          }
        }
      });
    }
  });

  // Update this.defectList targeted to just the removed entry — not scoped to one station
  if (isExistingDefect) {
    // Mark as deleted in the full list
    this.defectList = this.defectList.map((d: any) =>
      d.Id === event.defectId ? { ...d, IsDeleted: true } : d
    );
  } else {
    // Remove new defect entirely from the full list
    this.defectList = this.defectList.filter((d: any) => d.Id !== event.defectId);
  }

  // Sync from sessionStorage first — createDefectedTask writes entries directly to sessionStorage
  // without updating this.defectFormList, so the in-memory copy is stale. Filtering a stale list
  // and writing it back would silently drop any entries added since the last sync.
  this.defectFormList = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectFormList || [];

  this.defectFormList = this.defectFormList.filter((form: any) => form.defectId !== event.defectId);
  // Persist updates
  let cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
  cqmsDefectItems = { ...cqmsDefectItems, defectList: this.defectList, defectFormList: this.defectFormList };
  sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));

  let cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
  cqmsSessionItems = {...cqmsSessionItems, sectionList: this.sectionList, currentStationId: element.AssignedStationId};
  sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));

  this.qbuildSharedSrv.setCurrentDefectList(this.defectList);
  this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
  this.updateCurrentTabList(this.sectionList);
}

//Fix for observed defect removal bug
//checks for length of defects under the task and only removes the full task if there is only 1 defect remaining
finalDefectTask(element: any, defectTasks: any) {
  let checkList: any[] = [];
  defectTasks.forEach((defect: any) => {
    if(defect.TaskExecutionId === element.Id && defect.IsDeleted !== true) {
      checkList.push(defect);
    }
  });

  
  if(checkList.length > 0) {
    return false; //there are defects remaining under this task
  } else {
    return true; //this is the last defect and the task can be removed from the station
  }
 
}

//TODO add call to dynamo to update data along with save
//will need to add some type of way to track sections that are signed off that can then be used in the UI
async signOffInspection(sectionId?: any): Promise<void> {
  const tabLength = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').currentTabList.length || 0;

  const dialogRef = this.qbuiltDialog.openInspectorDialog(4, [], this.userName);

  try {
    const result = await firstValueFrom(dialogRef.afterClosed());
    
    if (!result) {
      return;
    }

    await this.saveInspectionResult(result, sectionId);

    if (tabLength > 1) {
      if (this.singleWide || this.finalSection) {
        this.emitCompleteTab.emit({ serialNumber: this.serialNumber });
      }
      return;
    }

    // LAST TAB CASE
    if (this.singleWide || this.finalSection) {
      const id = `${this.facilityNumber}-${this.currentZoneId}`;

      // WAIT FOR DELETE TO COMPLETE
      try {
        await this.qbuiltInspSrv.deleteInspectionProgressFromDynamo(id);
        
        // Only clear AFTER delete finishes
        sessionStorage.removeItem(this.cqmsSessionKey);
        sessionStorage.removeItem(this.defectItemsKey);
        sessionStorage.removeItem('saveProgressDisabled');
        localStorage.removeItem('activeSerial');
        this.router.navigate(['/cqms-home']);
      } catch (err) {
        console.error('Delete failed, not clearing local state', err);
      }
    }
  } catch (err) {
    console.error('Error in sign-off process', err);
  }
}

async saveInspectionResult(userId: number, sectionId: any): Promise<void> {
  let section;
  let sectionName: string;
  const inspectionData = sessionStorage.getItem(this.cqmsSessionKey)
    ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').sectionList
    : [];

  if(this.singleWide) {
    sectionId = inspectionData[0].SectionId;
    section = inspectionData[0];
  } else {
    section = inspectionData.find((s: any) => s.SectionId === sectionId);
    const actualSectionName = inspectionData.find((s: any) => s.SectionId === sectionId)?.SectionName;
    sectionName = 'Section ' + actualSectionName;
    if(!this.completeSectionList.includes(sectionId)) {
      this.completeSectionList.push(sectionId);
    }
    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems.completeSectionList = this.completeSectionList;
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
  }

  if (!section) {
    console.error(`Section with ID ${sectionId} not found`);
    return;
  }

  //determine if its the last section to be signed off
  if(!this.singleWide && this.completeSectionList.length === this.sectionList.length) {
    this.finalSection = true;
  }

  const taskIdResults: TaskExecutionResultModel[] = [];
  const injectedTasks: InjectedTaskModel[] = [];
  const defectedTasks: DefectedTaskModel[] = [];

  let zoneId = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').zoneId : null;
  section.Stations.forEach((station: any) => {
    station.TaskExecutions.forEach((task: any) => {
      if (task.ResultValue) {
        if(typeof task.Id !== 'number') {task.Id = 0}
        taskIdResults.push({
          Id: task.Id,
          Result: task.ResultValue,
          StatusId: 4 //status id 4 for "Complete"
        });

        const injected = (task.InjectedTasks || []).map((injectedTask: any) => ({
          ...injectedTask,
          ExecutionTaskId: task.Id
        }));

        injectedTasks.push(...injected);
      }
    });
  });
  const tabList = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').currentTabList || [];
  tabList.forEach((tab: any) => {
    if(tab.serialNumber === this.serialNumber) {
      this.sectionList = tab.sectionList;
      this.sectionList.forEach((sec: any) => {
        if(sec.SectionId === sectionId) {
          sec.isComplete = true; // mark section as complete for UI purposes
          sec.Stations.forEach((station: any) => {
            station.DefectedTasks.forEach((defect: any) => {
              if(typeof defect.Id !== 'number') {defect.Id = 0}
              if(typeof defect.TaskExecutionId === 'string') {
              defect.TaskExecutionId = 0;
            }
              defectedTasks.push(defect);
            });
            
            station.TaskExecutions.forEach((task: any) => {
              if(typeof task.Id !== 'number') {task.Id = 0}
              const result = taskIdResults.find(r => r.Id === task.Id);
              if (result) {
                task.ResultValue = result.Result;
                task.TaskStatusId = result.StatusId; // mark as complete
              }
            });
          });
        }
      });
    }
  });

  sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify({ ...JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}'), sectionList: this.sectionList }));
  tabList.forEach((tab: any) => {
    if (tab.serialNumber === this.serialNumber) {
      tab.sectionList = this.sectionList;
    }
  });

  const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
  cqmsSessionItems.tabList = tabList;
  sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));

  await this.qbuiltInspSrv.saveInspectionProgressToDynamo(this.facilityNumber, this.currentZoneId, tabList);
  
  const completionObj: InspectionCompletionModel = {
    SignedOffByQTUserId: userId,
    HBGInspectionStatusId: this.singleWide || this.finalSection ? 4 : 2, //4 = complete for single wide or final section and 2 for in progress
    ZoneId: parseInt(zoneId),
    SectionId: sectionId,
    TaskResults: taskIdResults,
    InjectedTasks: injectedTasks,
    DefectedTasks: defectedTasks
  };

  try {
    const res = await this.qbuiltInspSrv.saveInspectionCompletionResults(completionObj);
    
    if(this.singleWide || this.finalSection) {
      this.toaster.open('Inspection on ' + this.zoneSelection + ' for Serial # ' + this.serialNumber + ' completed!', 'Close', { duration: 5000 });
    } else {
      this.toaster.open('Inspection on ' + sectionName + ' for Serial # ' + this.serialNumber + ' completed!', 'Close', { duration: 5000 });
    }
  } catch (err) {
    console.error(`Error saving inspection`, err);
  }
}

  inspectionValidCheck(sectionId?: any): boolean {
    const inspectionData = this.sectionList;

    const rawDefect = sessionStorage.getItem(this.defectItemsKey);
    const defectFormList = rawDefect ? (JSON.parse(rawDefect).defectFormList || []) : [];

    const allTasks: TaskExecution[] = [];
    const allDefects: DefectModel[] = [];

    if (sectionId) {
      const section = inspectionData.find((s: any) => s.SectionId === sectionId);
      if (section) {
        section.Stations.forEach((station: any) => {
          allTasks.push(...station.TaskExecutions);
          allDefects.push(...station.DefectedTasks);
        });
      }
    } else {
      inspectionData.forEach((section: any) => {
        section.Stations.forEach((station: any) => {
          allTasks.push(...station.TaskExecutions);
          allDefects.push(...station.DefectedTasks.filter((defect: any) => defect.IsDeleted !== true));
        });
      });
    }

    //if there are no defects
    if(allDefects.length === 0) {
      //checks that in task result value none of them are empty (new) and none of them are marked as defect
      //this returns true
      this.saveProgressValidationCheck(allTasks.some(task => !task.ResultValue || task.ResultValue === 'Defect'));
      return allTasks.some(task => !task.ResultValue || task.ResultValue === 'Defect');
    } else {
      //checks if there are any tasks without a result value (new) or 'open tasks'
      const openTask = allTasks.some(task =>!task.ResultValue);
      //checks if there are any defects with the status of 1 (new state) 5 (open defects) or defects with IsDeleted == true (might be able to remove this)
      const openDefect = allDefects.some(defects => (defects?.StatusId === 1 || defects?.StatusId === 5) && defects?.IsDeleted !== true);      
      //this checks if there are defects in status 2 (deferred) that have not yet been designated to a station
      //this line wasnt included in the check for some reason
      const openDesignatedDefect = defectFormList.some((d: any) => d.statusId === 2 && d.designateStation === false);

      this.saveProgressValidationCheck(openTask || openDefect);
      return (openTask || openDefect);
    }
  }

  //checks if at least one of the inspection valid checks is true then will set session storage value to be used to disable the save progress button
  saveProgressValidationCheck(submissionBoolean: boolean) {   
    this.qbuiltInspSrv.booleanList.next([...this.qbuiltInspSrv.booleanList.getValue(), submissionBoolean]);
    if(this.qbuiltInspSrv.booleanList.getValue().some(bool => bool === false)) {
      sessionStorage.setItem('saveProgressDisabled', 'false');
    } else {
      sessionStorage.setItem('saveProgressDisabled', 'true');
    }
  }

  //Checks if element is anything but Pass
  //if so then there is a drop down panel with more information
  notPassCheck(element: any): boolean {
    return (element.ResultValue !== 'Pass' && element.ResultValue !== null);
  }

  //captures if the user checked or unchecked the DNI box -- TODO - make sure this works properly with the customTaskGroupCall
  handleDNIChange(didNotInspect: boolean, element: any) {
    const InjectedTasks: InjectedTaskModel[] = [];
    InjectedTasks.push({
      Id: 0,
      ExecutionTaskId: element.Id,
      StatusId: element.StatusId,
      TaskId: element.TaskId,
      ResultValue: didNotInspect ? 'true' : 'false'
    });

    element['InjectedTasks'] = InjectedTasks;

    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems.sectionList = this.sectionList;
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));

    this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
    this.updateCurrentTabList(this.sectionList);
  }


  //Gets comment value from user input
  handleNaComment(comment: string, element: any) {
    if (!element.InjectedTasks || !Array.isArray(element.InjectedTasks)) {
      element.InjectedTasks = [];
    }
    
    const existingCommentIndex = element.InjectedTasks.findIndex(
      (task: InjectedTaskModel) => task.Name === 'Comment'
    );
    
    const commentTask: InjectedTaskModel = {
      Id: 0,
      ExecutionTaskId: element.Id,
      StatusId: element.StatusId,
      TaskId: element.TaskId,
      ResultValue: comment,
      Name: 'Comment'
    };
    
    if (existingCommentIndex >= 0) {
      element.InjectedTasks[existingCommentIndex] = commentTask;
    } else {
      element.InjectedTasks.push(commentTask);
    }

    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems.sectionList = this.sectionList;
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
    this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
    this.updateCurrentTabList(this.sectionList);
  }

  //Handles location change from defect form component
  onLocationChange(event: any, sectionId: number, element: any) {
    this.updateData(event, sectionId, element);

  }

  //Handles quantity change from defect form component
  onQuantityChange(event: any, sectionId: number, element: any) {
    this.updateData(event, sectionId, element);
  }

  //Handles description change from defect form component -- EVENT NOT FIRING
  onDescriptionChange(event: any, sectionId: number, element: any) {
    this.updateData(event, sectionId, element);
  }


updateData(defectTask: any, sectionId: number, element: any) { //cat version
  this.sectionList.forEach(section => {
    if(section.SectionId === sectionId) {
      section.Stations.forEach((station:any) => {
        if(station.Id === element.AssignedStationId) {
          if(station.DefectedTasks) {
            station.DefectedTasks = station.DefectedTasks.map((d: any) => d.Id === defectTask.Id ? defectTask : d);
          }
        }
      });
    }
  });

  //update data in defectlist
  const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
  this.defectList = this.defectList.map((d: any) => d.Id === defectTask.Id ? defectTask : d);
  cqmsDefectItems.defectList = this.defectList;
  sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
  this.qbuildSharedSrv.setCurrentDefectList(this.defectList);

  //update data in session storage for section list
  const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
  cqmsSessionItems.sectionList = this.sectionList;
  sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
  this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
  this.updateCurrentTabList(this.sectionList);
}


  handleDNIStatus(isChecked: boolean, element: any) {
    if (!element.InjectedTasks || !Array.isArray(element.InjectedTasks)) {
      element.InjectedTasks = [];
    }
    
    const existingDniIndex = element.InjectedTasks.findIndex(
      (task: InjectedTaskModel) => task.Name === this.qBuiltInspectorConstants.didNotInspect
    );
    
    if (isChecked) {
      const dniTask: InjectedTaskModel = {
        Id: 0,
        ExecutionTaskId: element.Id,
        StatusId: element.StatusId,
        TaskId: element.TaskId,
        Name: this.qBuiltInspectorConstants.didNotInspect,
        ResultValue: isChecked ? 'true' : 'false'
      };
      
      if (existingDniIndex >= 0) {
        element.InjectedTasks[existingDniIndex] = dniTask;
      } else {
        element.InjectedTasks.push(dniTask);
      }
    } else {
      if (existingDniIndex >= 0) {
        element.InjectedTasks.splice(existingDniIndex, 1);
      }
    }
    
    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems.sectionList = this.sectionList;
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
    this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
    this.updateCurrentTabList(this.sectionList);
  }


  onExpandElement(element: any) {
    if (element.ResultValue === null) {
      this.expandedElement = null
      return
    }
    this.expandedElement = this.expandedElement === element ? null : element
  }

  //fix defect button to mark as complete
  onEmitCompleteDefect(defect: any, sectionId: number, element: any) {
    //filter by defect id then map updates
    let updatedDefect = this.defectList.filter(d => d.Id === defect.defectId).map(d => ({...d, 
      Id: defect.defectId,
      TaskExecutionId: element.Id,
      LocationId: defect.locationId,
      DepartmentId: defect.departmentId,
      StatusId: 3, 
      StationId: null,
      ClosedByQTUserId: this.userId,
      Description: defect.defectDesc,
      DefectQuantity: defect.quantity
    }));
    //update defect list based on defect id
    this.defectList = this.defectList.map(d => d.Id === defect.defectId ? updatedDefect[0] : d);
    const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
    cqmsDefectItems.defectList = this.defectList;
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
    this.qbuildSharedSrv.setCurrentDefectList(this.defectList);
    //update the defect list based on section and station
    this.sectionList.forEach(section => {
      if(section.SectionId === sectionId) {
        section.Stations.forEach((station:any) => {
          if(station.Id === element.AssignedStationId) {
            station.DefectedTasks = station.DefectedTasks.map((d: any) => d.Id === defect.defectId ? updatedDefect[0] : d);
          }
        });
      }
    });

    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems.sectionList = this.sectionList;
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
    this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
    this.updateCurrentTabList(this.sectionList);
  }

  //Designate Defect to new station - updates status of defect to 2 (deferred) 
  //new defect is created in DB and will appear in that new station
  //remaining defect is disabled
  onEmitDesignateDefect(defect: any, passedSection: any, element: any) {
       let updatedDefect = this.defectList.filter(d => d.Id === defect.defectId).map(d => ({...d, 
        Id: defect.defectId,
        TaskExecutionId: element.Id,
        TaskName: element.TaskName,
        LocationId: defect.locationId,
        DepartmentId: defect.departmentId,
        StatusId: 2, 
        ClosedByQTUserId: this.userId,
        Description: defect.defectDesc,
        DefectQuantity: defect.quantity,
        StationId: defect.stationId,
        SectionName: passedSection.SectionName
    }));
    //update the defect list based on defect id
    this.defectList = this.defectList.map(d => d.Id === defect.defectId ? updatedDefect[0] : d);
    const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
    cqmsDefectItems.defectList = this.defectList;
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
    this.qbuildSharedSrv.setCurrentDefectList(this.defectList);
    //update the defect list based on section and station
    this.sectionList.forEach(section => {
      if(section.SectionId === passedSection.SectionId) {
        section.Stations.forEach((station:any) => {
          if(station.Id === element.AssignedStationId) {
            station.DefectedTasks = station.DefectedTasks.map((d: any) => d.Id === defect.defectId ? updatedDefect[0] : d);
          }
        });
      }
    });
    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems.sectionList = this.sectionList;
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
    this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
    this.updateCurrentTabList(this.sectionList);
  }

  //I know its repetative but it had to be this way dont mess with perfection :S
  onEmitDesignateDefectOpen(event: any, passedSection: any, StationId: any) {
    let defect = event.defect;
    let stationId = event.stationResults.Id;
    //filter by defect id then map updates
    let updatedDefect = this.defectList.filter(d => d.Id === defect.Id).map(d => ({...d, 
        Id: defect.Id,
        TaskExecutionId: defect.TaskExecutionId,
        LocationId: defect.LocationId,
        DepartmentId: defect.DepartmentId,
        StatusId: 2, 
        ClosedByQTUserId: this.userId,
        Description: defect.Description,
        DefectQuantity: defect.DefectQuantity,
        StationId: stationId,
        SectionName: passedSection.SectionName,
    }));
    //update the defect list based on defect id
    this.defectList = this.defectList.map(d => d.Id === defect.Id ? updatedDefect[0] : d);
    const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
    cqmsDefectItems.defectList = this.defectList;
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
    this.qbuildSharedSrv.setCurrentDefectList(this.defectList);

    //update the defect list based on section and station
    this.sectionList.forEach(section => {
      if(section.SectionId === passedSection.SectionId) {
        section.Stations.forEach((station:any) => {
          if(station.Id === StationId) {
            station.DefectedTasks = station.DefectedTasks.map((d: any) => d.Id === defect.Id ? updatedDefect[0] : d);
          }
        });
      }
    });

    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems.sectionList = this.sectionList;
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
    this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
    this.updateCurrentTabList(this.sectionList);

  }

  //Marking an open defect as fixed -- sets stationId to null and updates status to 3
  onEmitFixedDefectOpen(defect: any, passedSection: any, StationId: any) {
    let updatedDefect = this.defectList.filter(d => d.Id === defect.Id).map(d => ({...d, 
        Id: defect.Id,
        TaskExecutionId: defect.TaskExecutionId,
        LocationId: defect.LocationId,
        DepartmentId: defect.DepartmentId,
        StatusId: 3,
        ClosedByQTUserId: this.userId,
        Description: defect.Description,
        DefectQuantity: defect.DefectQuantity,
        StationId: null,
        SectionName: passedSection.SectionName,
    }));
    //update the defect list based on defect id
    this.defectList = this.defectList.map(d => d.Id === defect.Id ? updatedDefect[0] : d);
    const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
    cqmsDefectItems.defectList = this.defectList;
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
    this.qbuildSharedSrv.setCurrentDefectList(this.defectList);

    //update the defect list based on section and station
    this.sectionList.forEach(section => {
      if(section.SectionId === passedSection.SectionId) {
        section.Stations.forEach((station:any) => {
          if(station.Id === StationId) {
            station.DefectedTasks = station.DefectedTasks.map((d: any) => d.Id === defect.Id ? updatedDefect[0] : d);
          }
        });
      }
    });
    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems.sectionList = this.sectionList;
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
    this.qbuildSharedSrv.setCurrentDataList(this.sectionList);
    this.updateCurrentTabList(this.sectionList);
  }


  //Keep the current tablist data updated from parent component
  //use the active serial from the session storage
  updateCurrentTabList(sectionList: any[]) {
    const raw = sessionStorage.getItem(this.cqmsSessionKey);
    const cqmsSessionItems = raw ? JSON.parse(raw) : {};
    const activeSerial = cqmsSessionItems.activeSerial || '';
    const updatedTabList = (cqmsSessionItems.currentTabList || []).map((tab: any) => {
      if(tab.serialNumber === activeSerial) {
        return {...tab, sectionList: sectionList};
      }
      return tab;
    });
    cqmsSessionItems.currentTabList = updatedTabList;
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
  }
  
}